<template>
  <div class="workshops-page inner">
    <site-menu theme="dark" class="menu"/>
    <header>
      <img src="../assets/workshops/workshops.jpg" class="illustration"/>
      <div class="content">
        <div class="map">
          <a href="https://www.google.com/maps/place/Blind+Whino+SW+Arts+Club/@38.8804444,-77.0141064,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7b77e4ad25f25:0x72ef04135d142f3f!8m2!3d38.8804444!4d-77.0119177" target="_blank">
            <img src="../assets/about/workshops_map.png" />
          </a>
        </div>
        <h1>CPES Workshops</h1>
        <p>The CPES workshops will be led by industry leaders and field experts, offering a hands-on approach around the topics of:</p>
        <ul>
          <li>&middot; Cultivation</li>
          <li>&middot; Processing</li>
          <li>&middot; Retail/Sales,</li>
          <li>&middot; Investing and Legal Matters in the cannabis industry</li>
        </ul>
        <p>Open to attendees and the general public these workshops will be held at the SW Arts Club a unique space renowned for its world-class events. To learn more about registering and the complete schedule for the workshops sign up to our newsletter</p>
        <subscribe css-class="big" placeholder="Enter email here" />
      </div>
    </header>
    <div class="table" v-if="showAsTable">
      <div class="table-row th">
        <div class="table-cell" v-for="track in tracks">{{track.title1}}:<br/>{{track.title2}}</div>
      </div>
      <div class="table-row odd">
      </div>
      <div class="table-row" v-for="i in 5" :class="{odd: i % 2}">
        <div class="table-cell" v-for="track in tracks">
          <div class="content">
            {{track.sessions[i - 1].title}}
          </div>
          <div class="date">{{track.sessions[i - 1].date}}</div>
        </div>
      </div>
    </div>
    <div class="list" v-if="!showAsTable">
      <div class="track" v-for="track in tracks">
        <h1>{{track.title1}}: {{track.title2}}</h1>
        <ul>
          <li v-for="session in track.sessions">
            <div class="title">{{session.title}}</div>
            <div class="date">{{session.date}}</div>
          </li>
        </ul>
      </div>
    </div>
    <img src="../assets/workshops/illustration.jpg" class="bottom-illustration"/>
    <divider />
  </div>
</template>
<script>
  import Divider from '@/components/Divider.vue'
  import RegisterButton from '@/components/RegisterButton.vue'
  import SiteMenu from '@/components/SiteMenu.vue'
  import Subscribe from '@/components/Subscribe.vue'

  export default {
    name: 'workshops-page',
    components: { Divider, SiteMenu, RegisterButton, Subscribe },
    data() {
      return {
        tracks: [{
          title1: 'Track 1',
          title2: 'Cultivation',
          sessions: [{
            title: 'Commercial Cannabis Cultivation',
            date: 'date/time',
          }, {
            title: 'Techniques for Growing Year Round',
            date: 'date/time',
          }, {
            title: 'Seed Evaluation',
            date: 'date/time',
          }, {
            title: 'Watering, Lighting, Ventilation, Cycles',
            date: 'date/time',
          }, {
            title: 'Equipments Do\'s & Don\'t',
            date: 'date/time',
          }, {
            title: 'Pest Control',
            date: 'date/time',
          }],
        }, {
          title1: 'Track 2',
          title2: 'Processing',
          sessions: [{
            title: 'Mass Production of Infused Products',
            date: 'date/time',
          }, {
            title: 'Cost of Production of Vape',
            date: 'date/time',
          }, {
            title: 'Manufacturing Concentrates: Challenges',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }],
        }, {
          title1: 'Track 3',
          title2: 'Retail/Sale',
          sessions: [{
            title: 'Success of Cannabis through Design and Branding',
            date: 'date/time',
          }, {
            title: 'Security and Insurance',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }],
        }, {
          title1: 'Track 4',
          title2: 'Investing',
          sessions: [{
            title: 'How to Structure your Cannabis Business Plan',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }],
        }, {
          title1: 'Track 5',
          title2: 'Legal',
          sessions: [{
            title: 'The Grey Market: How to stay legal in a changing environment',
            date: 'date/time',
          }, {
            title: 'How to file taxes',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }, {
            title: 'TBD',
            date: 'date/time',
          }],
        }],
      }
    },
    computed: {
      showAsTable() {
        return window.innerWidth > 500
      },
    },
  }
</script>
<style lang="scss" scoped>
  h1 {
    font-family: Times, 'Times New Roman', serif;
    font-size: 35px;
    color: $color-2;
    padding: 0;
    margin: 0;
  }
  header {
    overflow: hidden;
    margin-top: 50px;
    .illustration {
      width: 630px;
      float: left;
    }
    .content {
      position: relative;
      float: left;
      padding-left: 20px;
      width: 630px;
      height: 420px;
      color: #888;
      .map {
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 0;
        height: 225px;
        opacity: 0.2;
        overflow: hidden;
        z-index: -1;
        img {
          width: 100%;
        }
      }
    }
  }
  .bottom-illustration {
    margin-top: 30px;
    width: 100%;
  }
  @media (max-width: 500px) {
    header {
      margin-top: 0;
      .illustration {
        width: 100%;
        float: none;
      }
      .content {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 15px;
      }
    }
    .map {
      display: none;
    }
    h1 {
      font-size: 23px;
      text-align: center;
    }
    .list .track {
      text-align: center;
      margin-bottom: 30px;
      .title {
        margin-top: 10px;
      }
      .date {
        text-transform: uppercase;
        letter-spacing: 1px;
        font-size: 11px;
        font-weight: bold;
        opacity: 0.5;
      }
    }
  }
  @media (min-width: 501px) {
    .table {
      margin: 40px 0;
      border-collapse: collapse;
      text-align: center;
      font-size: 18px;
      color: #666;
    }
    .table-row.th {
      color: #333;
    }
    .content {
      height: 60px;
    }
    .odd {
      background: #f0f0f0;
    }
    .table-cell {
      padding: 10px;
      border: 1px solid #aaa;
      position: relative;
      .date {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 5px;
        font-size: 12px;
        color: #222;
        letter-spacing: 1px;
      }
    }
  }
</style>
